import { Inject, Injectable } from '@angular/core';
import { EInvoiceReceivedGetHeaderXmlQuery } from '@skylab-angular-shared/business';
import { L10n, QueryBus } from '@skylab-angular-shared/core';
import { ToastService } from '@skylab-angular-shared/ui';
import { L10nBase } from '@skylab-shared/core';
import { saveAs } from 'file-saver-es';
import { RootContainerOverlayService } from '../../common/root-container-overlay.service';

@Injectable({ providedIn: 'root' })
export class EInvoiceReceivedXmlExportService {
    public constructor(
        private readonly queryBus: QueryBus,
        private readonly overlay: RootContainerOverlayService,
        private readonly toastService: ToastService,
        @Inject(L10n) private readonly l10n: L10nBase
    ) { }

    public async exportAsync(documentHeaderId: number | null | undefined): Promise<void> {
        if (!documentHeaderId) return;

        this.overlay.show();
        try {
            const result = await this.queryBus.queryAsync(new EInvoiceReceivedGetHeaderXmlQuery({ documentHeaderId }));
            if (!result?.filename) throw new Error('Received invoice XML is unavailable');

            saveAs(result.file, result.filename);
        } catch {
            this.toastService.showAsync({
                type: 'error',
                text: this.l10n._T('scenes.shared.e-invoice-received-xml-export.error')
            });
        } finally {
            this.overlay.hide();
        }
    }
}
